import script from "./WarehouseLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseLayout.vue?vue&type=script&setup=true&lang=js"

import "./WarehouseLayout.vue?vue&type=style&index=0&id=f3f1af80&scoped=true&lang=css"
import "./WarehouseLayout.vue?vue&type=style&index=1&id=f3f1af80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3f1af80"]])

export default __exports__